/* eslint-disable */

import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'user',
        title: 'Usuario',
        subtitle: 'Gestiona tu perfil',
        type: 'group',
        children: [
            {
                id: 'home.profile',
                title: 'Perfil',
                type: 'basic',
                link: 'profile/' + localStorage.getItem('user-id'),
                icon: 'feather:user',
            },
        ]
    },
    // {
    //     id      : 'home',
    //     title   : 'Aera Courier',
    //     subtitle: 'Tu servicio de paquetería',
    //     type    : 'group',
    //     children: [
    //         {
    //             id   : 'home.dashboard',
    //             title: 'Inicio',
    //             type : 'basic',
    //             link : 'dashboard',
    //             icon : 'mat_outline:dashboard',
    //         },
    //     ]
    // },
    {
        id: 'client-courier',
        title: 'Paquetería',
        subtitle: 'Gestión de Paquetería',
        type: 'group',
        children: [
            {
                id: 'client-courier.calculator',
                title: 'Calculadora',
                type: 'basic',
                link: 'calculator',
                icon: 'heroicons_outline:calculator',
            }, {
                id: 'client-courier.invoices',
                title: 'Facturas',
                type: 'basic',
                link: 'invoices',
                icon: 'heroicons_outline:currency-dollar',
            }, {
                id: 'client-courier.packages',
                title: 'Paquetes',
                type: 'basic',
                link: 'packages',
                icon: 'feather:box',
            }, {
                id: 'client-courier.consolidations',
                title: 'Consolidados',
                type: 'basic',
                link: 'consolidations',
                icon: 'mat_outline:layers',
            }, {
                id: 'client-courier.prealerts',
                title: 'Prealertas',
                type: 'basic',
                link: 'prealerts',
                icon: 'heroicons_outline:bell-alert',
            }, {
                id: 'client-courier.plans',
                title: 'Planes',
                type: 'basic',
                link: 'plans',
                icon: 'mat_outline:airplane_ticket',
            },

        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'admin/dashboard'
    }, {
        id: 'account',
        title: 'Cuentas',
        subtitle: 'Usuarios y Clientes',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'account.users',
                title: 'Usuarios',
                type: 'basic',
                link: 'admin/users',
                icon: 'feather:users',
            },
            {
                id: 'account.clients',
                title: 'Clientes',
                type: 'basic',
                link: 'admin/clients',
                icon: 'heroicons_outline:users',
            },
        ]
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'admin/dashboard'
    }, {
        id: 'account',
        title: 'Cuentas',
        subtitle: 'Usuarios y Clientes',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'account.users',
                title: 'Usuarios',
                type: 'basic',
                link: 'admin/users',
                icon: 'feather:users',
            },
            {
                id: 'account.clients',
                title: 'Clientes',
                type: 'basic',
                link: 'admin/clients',
                icon: 'heroicons_outline:users',
            },
        ]
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        subtitle: 'Panel de Control',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: 'admin/dashboard'
    }, {
        id: 'account',
        title: 'Cuentas',
        subtitle: 'Usuarios y Clientes',
        type: 'group',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'account.users',
                title: 'Usuarios',
                type: 'basic',
                link: 'admin/users',
                icon: 'feather:users',
            },
            {
                id: 'account.clients',
                title: 'Clientes',
                type: 'basic',
                link: 'admin/clients',
                icon: 'heroicons_outline:users',
            },
        ]
    }, {
        id: 'courier',
        title: 'Paquetería',
        subtitle: 'Gestión de Paquetería',
        type: 'group',
        icon: 'mat_outline:markunread_mailbox',
        children: [
            {
                id: 'courier.consolidations',
                title: 'Consolidados',
                type: 'basic',
                link: 'admin/consolidations',
                icon: 'mat_outline:layers',
            },
            {
                id: 'courier.packages',
                title: 'Paquetes',
                type: 'basic',
                link: 'admin/packages',
                icon: 'feather:box',
            },
            {
                id: 'courier.invoices',
                title: 'Histórico de Facturas',
                type: 'basic',
                link: 'admin/invoices',
                icon: 'feather:list',
            },
            {
                id: 'courier.bill',
                title: 'Facturar paquetes',
                type: 'basic',
                link: 'admin/bill',
                icon: 'heroicons_outline:currency-dollar',
            },
            {
                id: 'courier.prealerts',
                title: 'Prealertas',
                type: 'basic',
                link: 'admin/prealerts',
                icon: 'heroicons_outline:bell-alert',
            },
            {
                id: 'courier.quotations',
                title: 'Cotizaciones',
                type: 'basic',
                link: 'admin/quotations',
                icon: 'mat_outline:request_quote',
            },
            {
                id: 'courier.restricted',
                title: 'Restringidos',
                type: 'basic',
                link: 'admin/restricted',
                icon: 'mat_outline:vpn_lock',
            },
            {
                id: 'courier.plan-requests',
                title: 'Gestión de Planes',
                type: 'basic',
                link: 'admin/plan-requests',
                icon: 'mat_outline:request_quote',
            },
        ]
    }, {
        id: 'tools',
        title: 'Herramientas',
        subtitle: 'Recursos y Herramientas',
        type: 'group',
        icon: 'feather:tool',
        children: [
            {
                id: 'tools.calculator',
                title: 'Calculadora',
                type: 'basic',
                link: 'admin/calculator',
                icon: 'heroicons_outline:calculator',
            },
            {
                id: 'courier.plans',
                title: 'Planes',
                type: 'basic',
                link: 'admin/plans',
                icon: 'mat_outline:airplane_ticket',
            },
            {
                id: 'courier.fees',
                title: 'Tarifas',
                type: 'basic',
                link: 'admin/fees',
                icon: 'mat_outline:feed',
            },
            {
                id: 'tools.notifications',
                title: 'Notificaciones',
                type: 'basic',
                link: 'admin/notifications',
                icon: 'mat_outline:message',
            },
            {
                id: 'tools.notifications',
                title: 'Heroes',
                type: 'basic',
                link: 'admin/heroes',
                icon: 'heroicons_outline:window',
            },
            {
                id: 'tools.exchange',
                title: 'Tipo de Cambio',
                type: 'basic',
                link: 'admin/tipo_cambio',
                icon: 'mat_outline:attach_money',
            },
            {
                id: 'tools.management-amount',
                title: 'Monto de Manejo',
                type: 'basic',
                link: 'admin/monto-manejo',
                icon: 'mat_outline:transfer_within_a_station',
            },
            {
                id: 'tools.activity-codes',
                title: 'Cód. de Actividad',
                type: 'basic',
                link: 'admin/activity-codes',
                icon: 'feather:activity',
            },
        ]
    },
];
export const contabilidadNavigation: FuseNavigationItem[] = [
    {
        id: 'contabilidad',
        title: 'Contabilidad',
        subtitle: 'Acceso de Contabilidad',
        type: 'group',
        children: [
            {
                id: 'contabilidad.invoices',
                title: 'Histórico de Facturas',
                type: 'basic',
                link: 'admin/invoices',
                icon: 'feather:list',
            },
            {
                id: 'contabilidad.calculator',
                title: 'Calculadora',
                type: 'basic',
                link: 'admin/calculator',
                icon: 'heroicons_outline:calculator',
            },
        ]
    }
];
